export enum COURSE_TEMPLATES_STORE {
  SET_COURSE_TEMPLATES = 'CourseTemplateStore/setCourseTemplates',
  INI_COURSE_TEMPLATES = 'CourseTemplateStore/initCourseTemplates',
  CREATE_COURSE_TEMPLATE = 'CourseTemplateStore/createCourseTemplate',
  GET_COURSE_TEMPLATES = 'CourseTemplateStore/getCourseTemplates',
  CREATE_COURSE_FROM_TEMPLATE = 'CourseTemplateStore/createCourseFromTemplate',
  GET_COURSE_TEMPLATE = 'CourseTemplateStore/getCourseTemplate',
  SET_TEMPLATE_MODE = 'CourseTemplateStore/setTemplateMode',
  SET_MY_TEMPLATE_SECTION_VISIBLE_MODE = 'CourseTemplateStore/setMyTemplateSectionVisibleMode',
  UPDATE_MY_TEMPLATE_SECTION_VISIBLE_MODE = 'CourseTemplateStore/updateSectionVisibleMode',
  GET_MY_COURSE_TEMPLATES = 'CourseTemplateStore/getMyCourseTemplates',
  SET_MY_COURSE_TEMPLATES = 'CourseTemplateStore/setMyCourseTemplates',
  SET_PURCHASED_TEMPLATES = 'CourseTemplateStore/setPurchasedTemplates',
  GET_GRADE_LEVELS = 'CourseTemplateStore/getGradeLevels',
  SET_GRADE_LEVELS = 'CourseTemplateStore/setGradeLevels',
  SET_GRADE_LEVEL_SELECTED = 'CourseTemplateStore/setGradeLevelSelected',
  PUBLISH_COURSE_TEMPLATE = 'CourseTemplateStore/publishCourseTemplate',
  SET_CHANGES_COURSE_TEMPLATE = 'CourseTemplateStore/setChangesCourseTemplates',
  SET_PUBLIC_COURSE_TEMPLATES = 'CourseTemplateStore/setPublicCourseTemplates',
  SET_PRIVATE_COURSE_TEMPLATES = 'CourseTemplateStore/setPrivateCourseTemplates',
  SET_MY_CONTENT_TEMPLATES = 'CourseTemplateStore/setMyContentTemplates',
  CREATE_SECTION_FOLDER = 'CourseTemplateStore/createSectionFolder',
  SET_COURSE_TEMPLATE_CONTENT = 'CourseTemplateStore/setCourseTemplateContent',
  SET_TEMPLATE_INFO = 'CourseTemplateStore/setTemplateInfo',
  REMOVE_COURSE_TEMPLATE = 'CourseTemplateStore/removeCourseTemplate',
  REMOVE_COURSE_TEMPLATE_M = 'CourseTemplateStore/removeCourseTemplateM',
  BLOCK_COURSE_TEMPLATE =  'CourseTemplateStore/blockCourseTemplate',
  UNBLOCK_COURSE_TEMPLATE =  'CourseTemplateStore/unblockCourseTemplate',
  BLOCK_COURSE_TEMPLATE_M =  'CourseTemplateStore/blockCourseTemplateM',
  UNBLOCK_COURSE_TEMPLATE_M =  'CourseTemplateStore/unblockCourseTemplateM',
  RESET_COURSE_TEMPLATES = 'CourseTemplateStore/resetCourseTemplates',
  SET_SHARED_TEMPLATES = 'CourseTemplateStore/setSharedTemplates',
  UPDATE_COURSE_TEMPLATE_STATUS = 'CourseTemplateStore/updateCourseTemplateStatus',
  GET_COURSE_TEMPLATE_STATUS_BY_ID = 'CourseTemplateStore/getCourseTemplateStatusById',
  INIT_MY_CONTENT_TEMPLATE_PAGINATION = 'CourseTemplateStore/initMyContentTemplate',
  SET_FIRT_CONTENT_TEMPLATE = 'CourseTemplateStore/setFirstTimeContentTemplate',
}
